<template>
  <div :id="id">
    <v-expansion-panel :value="expandPanelNr">
      <v-expansion-panel-content expand-icon="arrow_drop_down">
        <div v-if="categoriesSelectedStr.length < 50" slot="header">
          {{ categoriesSelectedStr }}
        </div>
        <div v-else slot="header">
          {{ categoriesSelectedStr.substr(0, 49) + "..." }}
        </div>
        <v-treeview
          v-model="categoriesSelected"
          :items="categoriesAllLocal"
          item-key="UniqueId"
          item-text="Name"
          item-children="SubCategories"
          activatable
          active-class="grey lighten-4 indigo--text"
          selected-color="indigo"
          open-on-click
          selectable
          return-object
          expand-icon="arrow_drop_down"
          on-icon="check_box"
          off-icon="check_box_outline_blank"
          indeterminate-icon="indeterminate_check_box"
        ></v-treeview>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
export default {
  name: "CategoriesTree",
  props: {
    id: String,
    categoriesAll: Array,
    expandByDefault: {
      default: null,
      type: Number,
    },
  },
  data() {
    return {
      categoriesAllLocal: [],
      categoriesSelected: [],
      categoriesSelectedStr: "",
      idPostfix: ":Name="
    };
  },
  computed: {
    expandPanelNr() {
      return this.expandByDefault;
    }
  },
  mounted() {
    console.log("categoriesAll in mounted: ", this.id, this.categoriesAll);
    this.init();
  },
  beforeDestroy() {
    this.categoriesSelected = [];
    this.categoriesSelectedStr = "";
  },
  watch: {
    categoriesSelected(newVal, oldVal) {
      this.categoriesSelectedStr = "";
      for (let category of this.categoriesSelected) {
        if (this.categoriesSelectedStr.length > 0) {
          this.categoriesSelectedStr += ",";
        }
        this.categoriesSelectedStr += category.Name;
      }
      this.$emit("categoriesSelected", this.categoriesSelected);
    },
  },
  methods: {
    init() {
      // Init selected insterests
      this.categoriesSelected = [];
      this.categoriesSelectedStr = "";
      this.categoriesAllLocal = [...this.categoriesAll];
      if (this.categoriesAllLocal !== undefined) {
        this.generateUniqueId();
        this.initSelectedCategories(this.categoriesAllLocal);
      }
    },
    initSelectedCategories(categoriesArray) {
      for (let category of categoriesArray) {
        if (category.Selected) {
          this.categoriesSelected.push(category);
          if (this.categoriesSelectedStr.length > 0) {
            this.categoriesSelectedStr += ",";
          }
          this.categoriesSelectedStr += category.Name;
        }

        // Check SubCategories
        if (
          category.hasOwnProperty("SubCategories") &&
          category.SubCategories.length > 0
        ) {
          for (let subCategory of category.SubCategories) {
            if (subCategory.Selected) {
              this.categoriesSelected.push(subCategory);
              if (this.categoriesSelectedStr.length > 0) {
                this.categoriesSelectedStr += ",";
              }
              this.categoriesSelectedStr += subCategory.Name;
            }
          }
        }
      }
    },
    generateUniqueId() {
      for (let category of this.categoriesAllLocal) {
        let mainCompositeId = category.InterestId + this.idPostfix + category.Name;
        category.UniqueId = mainCompositeId;
        if (
          category.hasOwnProperty("SubCategories") &&
          category.SubCategories.length > 0
        ) {
          for (let subCategory of category.SubCategories) {
            let subCompositeId = subCategory.InterestId + this.idPostfix + subCategory.Name;
            subCategory.UniqueId = subCompositeId;
          }
        }
      }
    }
  },
};
</script>

<style scoped>
</style>